import React, { useState } from "react";
import { Menu, MenuItem, darkScrollbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import config from "environment";
import { useDispatch, useSelector } from "react-redux";
import {
  selectUIStates,
  selectUser,
  setSelectedMenu,
  setSelectedMenuId,
  setUIStates,
} from "../../redux/features/appData/appDataSlice";
import "./AvatarMenu.css";
import "../../css/Icons.css";
import { MENUS } from "../config/menus";
import { iconPath } from "winslow-core";

const AVATAR_MENU = {
  LOGOUT: "logout",
  PERSONAL: "personal",
  WORKSPACE: "workspace",
  BILLING: "billing",
  GMAIL: "gmail",
};

type AvatarMenuProps = {
  image: string;
};

export default function AvatarMenu({ image }: AvatarMenuProps) {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storeUser = useSelector(selectUser);
  const uiStates = useSelector(selectUIStates);

  const { logout } = useAuth0();

  const closeSnippetSidebar = () => {
    dispatch(
      setUIStates({
        ...uiStates,
        snippetSidebarOpen: false,
        snippetEdited: false,
      })
    );
  };

  const handleButtonClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuSelection = (selection: string) => {
    // close the menu
    setAnchorEl(null);

    // no floaters on avatar menu pages
    dispatch(
      setUIStates({
        ...uiStates,
      })
    );

    // route it
    switch (selection) {
      case AVATAR_MENU.PERSONAL:
        closeSnippetSidebar();
        dispatch(setSelectedMenu(MENUS.UNSELECTED));
        dispatch(setSelectedMenuId(undefined));
        navigate("/settings");
        break;
      case AVATAR_MENU.WORKSPACE:
        closeSnippetSidebar();
        dispatch(setSelectedMenu(MENUS.UNSELECTED));
        dispatch(setSelectedMenuId(undefined));
        navigate("/workspaces");
        break;
      case AVATAR_MENU.BILLING:
        closeSnippetSidebar();
        dispatch(setSelectedMenu(MENUS.UNSELECTED));
        dispatch(setSelectedMenuId(undefined));
        navigate("/billing");
        break;
      case AVATAR_MENU.LOGOUT:
        navigate("/logout");
        break;
      case AVATAR_MENU.GMAIL:
        navigate("/plugins");
        break;
      default:
    }
  };

  return (
    <>
      <div className="avatar-image-and-name" onClick={handleButtonClick}>
        <div className="avatar-image">
          <img src={image} alt="" />
        </div>
        <div className="avatar-name">
          {storeUser?.firstName} {storeUser?.lastName}
        </div>
        <div className="avatar-caret">
          <img src={iconPath("down.svg", storeUser)} alt="" />
        </div>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}>
        <MenuItem onClick={() => handleMenuSelection(AVATAR_MENU.WORKSPACE)}>
          Workspace Settings
        </MenuItem>
        <MenuItem onClick={() => handleMenuSelection(AVATAR_MENU.PERSONAL)}>
          Personal Settings
        </MenuItem>
        {/* <MenuItem onClick={() => handleMenuSelection(AVATAR_MENU.BILLING)}>
          Upgrade and Billing
        </MenuItem>
        <MenuItem onClick={() => handleMenuSelection(AVATAR_MENU.GMAIL)}>
          Gmail Plugin
        </MenuItem> */}
        <MenuItem onClick={() => handleMenuSelection(AVATAR_MENU.LOGOUT)}>
          <span style={{ color: "var(--text-color-error)" }}>Log Out</span>
        </MenuItem>
      </Menu>
    </>
  );
}
